import { defineMessages } from "react-intl";

const baseId = "t.pages.DelegationManagementStepOne.";

export default defineMessages({
  addNewDelegation: {
    id: baseId + "addNewDelegation",
    defaultMessage: "Add new delegation",
  },
  panelTitle: {
    id: baseId + "panelTitle",
    defaultMessage: "Active delegations",
  },
  emptyDelegations: {
    id: baseId + "emptyDelegations",
    defaultMessage: "There are no delegations actives",
  },
  //FORM
  allFilterLabelForm: {
    id: baseId + "allFilterLabelForm",
    defaultMessage: "Name, surname",
  },
  CTAExit: {
    id: baseId + "CTAExit",
    defaultMessage: "Exit",
  },
});
